import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, ProtectedRoute, useAuth } from "./lib/auth";
import LoginPage from "./pages/LoginPage";
import ManagerDashboard from "./pages/ManagerDashboard";
import CeoDashboard from "./pages/CeoDashboard";
import LedgerPage from "./pages/LedgerPage";
import PayrollPage from "./pages/PayrollPage";
import ProductsPage from "./pages/ProductsPage";
import StaffPage from "./pages/StaffPage";
import UsersPage from "./pages/UsersPage";
import { Toaster } from "./components/ui/sonner";

function RoleRedirect() {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "CEO" ? "/ceo" : "/manager"} replace />;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<RoleRedirect />} />

            <Route path="/manager" element={
              <ProtectedRoute role="MANAGER"><ManagerDashboard /></ProtectedRoute>
            } />

            <Route path="/ceo" element={
              <ProtectedRoute role="CEO"><CeoDashboard /></ProtectedRoute>
            } />
            <Route path="/ceo/ledger" element={
              <ProtectedRoute role="CEO"><LedgerPage /></ProtectedRoute>
            } />
            <Route path="/ceo/payroll" element={
              <ProtectedRoute role="CEO"><PayrollPage /></ProtectedRoute>
            } />
            <Route path="/ceo/products" element={
              <ProtectedRoute role="CEO"><ProductsPage /></ProtectedRoute>
            } />
            <Route path="/ceo/staff" element={
              <ProtectedRoute role="CEO"><StaffPage /></ProtectedRoute>
            } />
            <Route path="/ceo/users" element={
              <ProtectedRoute role="CEO"><UsersPage /></ProtectedRoute>
            } />

            <Route path="*" element={<RoleRedirect />} />
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
